import { RootState } from '../store/types';

export const selectThemeMode = (state: RootState) => state.app.themeMode;
